export class DatePicker {
    private $input: JQuery;
    public onChange?: { (value: Date) };

    constructor($input?: JQuery, cfg?: object) {
        this.$input = $input === undefined ? $('<input type="text" class="form-control" readonly />') : $input;

        let baseCfg = {
            format: "dd.mm.yyyy",
            autoclose: true,
            clearBtn: true,
            language: "de",
            weekStart: 1,
            todayHighlight: true,
        };

        baseCfg = { ...baseCfg, ...cfg };

        this.$input.datepicker(baseCfg);
        this.$input.on("changeDate", (e) => {
            const minDate = e.date;
            if (this.onChange !== undefined) this.onChange(minDate);
        });
    }

    public getValue(): Date | undefined {
        const d = this.$input.datepicker("getUTCDate");
        if (d == null) return undefined;

        return d;
    }

    public setValue(value?: Date): DatePicker {
        this.$input.datepicker("setUTCDate", value === undefined ? null : value);
        if (value === undefined) this.$input.val("");

        return this;
    }

    public setEndDate(value?: Date): DatePicker {
        const valueToInsert = value === undefined ? null : value;

        this.$input.datepicker("setEndDate", valueToInsert);
        return this;
    }

    public setStartDate(value?: Date): DatePicker {
        const valueToInsert = value === undefined ? null : value;

        this.$input.datepicker("setStartDate", valueToInsert);
        return this;
    }

    public setError(hasError: boolean): DatePicker {
        if (hasError) this.$input.addClass("is-invalid");
        else this.$input.removeClass("is-invalid");

        return this;
    }

    public setDisabled(isDisabled: boolean): DatePicker {
        this.$input.prop("disabled", isDisabled);

        if (isDisabled) this.$input.addClass("disabled");
        else this.$input.removeClass("disabled");

        return this;
    }

    public renderTo($element: JQuery): DatePicker {
        this.$input.appendTo($element);
        return this;
    }
}
